import T from 'i18n-react';
import React from 'react';
import GenericNotificationWithLink from './GenericNotificationWithLinks';
import { viewTypes } from '../constants/view-types';

/**
 * Returns a reference to a promise and to it's resolve and reject methods
 * We need the reference to resolve and reject so we can resolve or reject this promise when needed
 * @returns {{promise: Promise, resolve: *, reject: *}}
 */
export const getPromiseForAsyncNotification = () => {
  let promiseResolve, promiseReject;
  const promise = new Promise((resolve, reject) => {
    promiseResolve = resolve;
    promiseReject = reject;
  });
  return {
    promise,
    resolve: promiseResolve,
    reject: promiseReject,
  };
};

export const trimFileName = (fileName, maxCharacters) => {
  return fileName.length > maxCharacters ? `${fileName.substr(0, maxCharacters - 7)}...${fileName.substr(fileName.length - 4)}` : fileName;
};

export const getNotificationTextForTransition = (viewType, translationKey, id, customIdentifier) => {
  const issueId = customIdentifier || T.translate('unspecifiedValue');
  const links = [
    {
      link: viewType === viewTypes.DOCUMENT ? `/rfis/${id}` : `/project/rfis/${id}`,
      text: `#${issueId}`,
    },
  ];
  return <GenericNotificationWithLink links={links} translationKey={translationKey} />;
};
